<template>
  <div class="appBase">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <div class="headRow">
      <!-- <div class="headRightPanel">
        <router-link to="/BackManagerLogin">
          管理员登录
        </router-link>
      </div> -->
    </div>

    <gloabl-message></gloabl-message>

    <transition name="fade">
      <div v-show="this.$store.state.sideBarState" :class="{'sideBar':true,'sideBarActive':sideBarActive||sideBarHover}" @mouseleave="sideBarHover=false">
          <div :class="{'barButtonBox':true,'barButtonActive':sideBarActive||sideBarHover}" @click="sideBarActive=!(sideBarActive||sideBarHover);sideBarHover=false;" ref="barButtonBox">
            <div class="barButton"></div>
          </div>
          <div class="callBar" @mouseenter="sideBarHover=true;">
          </div>
          <div class="sideBarHead">
            <div class="headInfo">
              <div class="profile" @click="routeToBackManager()" >
                <img src="./assets/svg/cake.svg">
                
              </div>
              <p @click="showAccessCode()" @mouseenter="sideBarTitleOver=true;" @mouseleave="sideBarTitleOver=false;">{{title}}</p>
              <div class="iocnBox">
                  <a target="_blank" title="gitee">
                    <img src="./assets/svg/gitee.svg" alt="">
                  </a>
                  <a target="_blank" title="github">
                      <img src="./assets/svg/github.svg" target="_blank" alt="">
                  </a>
                  <a target="_blank" title="weibo">
                      <img src="./assets/svg/weibo.svg" alt="">
                  </a>
                  <a target="_blank" title="bilibili">
                      <img src="./assets/svg/bili.svg" alt="">
                  </a>
              </div>
            </div>
          </div>
          <div class="sideBarButtonBox">
            <router-link to="/Home">
              <div class="sideBarButton" back-text="Home">主页</div>
            </router-link>
            <router-link to="/BlogIndex">
              <div class="sideBarButton" back-text="BlogIndex">博客</div>
            </router-link>
            <router-link to="/Archives">
              <div class="sideBarButton" back-text="Archives">归档</div>
            </router-link>
            <router-link to="/Introduction">
              <div class="sideBarButton" back-text="Introduction">介绍</div>
            </router-link>
          </div>
          <div class="exPanel">
            <!-- <div class="exButton">待办</div>
            <div class="exButton">番茄钟</div> -->
          </div>
      </div>
    </transition>
    <!-- <router-view></router-view> -->
    <router-view v-slot="{ Component , route }">
      <transition :name="route.meta.transition || 'slide-left'">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script>
import gloablMessage from '@/components/GloablMessage'
export default {
  name: 'App',
  components: {
    'gloabl-message':gloablMessage
  },
  data(){
    return{
      sideBarTitleOver:false,
      sideBarHover:false,
      sideBarActive:false
    };
  },
  computed:{
    title(){
      if (this.$cookies.get('accessCode')!=null) {
        if (this.sideBarTitleOver) {
          return '检查AccessCode'
        }
        return '管理员'
      }
      return '访客';
    }
  }
  ,
  methods:{
    routeToBackManager(){
      this.$router.push({ path: '/BackManager' })
    },showAccessCode(){
      this.$store.commit('messageAdd',{
                text:this.$cookies.get('accessCode')
      })
    }
  }
  ,
  mounted(){
  }
}
</script>

<style lang='scss'>
html{
  
  width: 100vw;
  height: 100vh;
}
body{
  border: 0;
  margin: 0;
  padding: 0;
  background-color: #222;
  transition: all 0s;
  width: 100%;
  height: 100%;
  font-size: 18px;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;  
  user-select: none;
  position: fixed;
}
#app{
  width: 100%;
  height: 100%;
}
.appBase {
  width: 100%;
  height: 100%;
  position: relative;
}
a {
  text-decoration: none;
}
*::-webkit-scrollbar {
  width: 5px;
}
*::-webkit-scrollbar-track {
  background-color: rgba(0,0,0,0);
}
*::-webkit-scrollbar-thumb {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 1) 100%);
  border-radius: 10px;
}
@media (max-width: 800px) {
    body,html{
      font-size: 12px;
    }
}
.headRow {
  color: white;
  font-size: 1.2rem;
  position: absolute;
  width: 100vw;
  z-index: 99;
  // .headRightPanel {
  //   position: absolute;
  //   top: 0;
  //   right: 0;
  //   width: 14rem;
  //   padding: .3rem;
  //   background-color: #111;
  //   opacity: .2;
  //   clip-path: polygon(0 0, 100% 0, 100% 100%, 25% 100%, 0 40%);
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   font-size: 1.8rem;
  //   letter-spacing: .2rem;
  //   text-indent: 1.5rem;
  //   cursor: pointer;
  //   a {
  //     color: #fff;
  //   }
  //   &:hover {
  //     opacity: 1;
  //   }
  // }
}
.barButtonBox{
  z-index: 999;
  position: absolute;
  top: .5rem;
  right: -4rem;
  padding: 2rem 1rem 2rem 1.5rem;
  cursor: pointer;
  .barButton{
    position: relative;
    width: 2rem;
    height: .25rem;
    background-color: rgba(255,255,255,1);
    transition: all .6s;
    &::before{
      content: "";
      position: absolute;
      top: -.5rem;
      width: 2rem;
      height: .25rem;
    transition: all .6s;
      background-color: #fff;
    }

    &::after{
      content: "";
      position: absolute;
      bottom: -.5rem;
      width: 2rem;
      height: .25rem;
    transition: all .6s;
      background-color: #fff;
    }
  }
}
.barButtonActive{
  .barButton{
    background-color: rgba(255,255,255,0);
    &::after{
      bottom:0;
      transform: rotate(135deg);
    }
    &::before{
      transform: rotate(225deg);
      top: 0;
    }
  }
}
@media (max-width: 800px) {
    .barButtonBox{
      transform: scale(1.5);
    }
  }

.sideBar {
  position: absolute;
  height: 100%;
  width: 24rem;
  background-color: #555;
  left: 0;
  top: 0;
  transform: translateX(-100%);
  z-index: 99;
  opacity: .8;
  backdrop-filter: blur(1rem);
    transition: all .6s;
  *{
    transition: all .6s;
  }
  .sideBarHead {
    width: 100%;
  }
  .callBar {
    height: 100%;
    width: 1rem;
    position: absolute;
    right: -1rem;
    background-image: linear-gradient(to bottom, rgba(50, 50, 50, 0) 10%, rgba(50, 50, 50, 1) 50%,rgba(50, 50, 50, 0) 90%);
    transition: opacity .5s;
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      height: 3rem;
      width: 5rem;
      background-color: #fff;
      transform: translate(-70% , -50%);
      border-radius: 50%;
      transition: filter 1s;
      opacity: 1;
      box-shadow: 0 0 10px rgb(0,140,255),
                0 0 25px rgb(0,140,255),
                0 0 50px rgb(0,140,255),
                0 0 100px rgb(0,140,255);
      filter: blur(2rem);
    }
  }
  @media (max-width: 800px) {
    .callBar{
      display: none;
    }
  }

  .sideBarButtonBox {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    a {
      width: 100%;
    }
    .sideBarButton {
      width: 80%;
      padding-left: 10%;
      padding-right: 10%;
      height: 5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 2rem;
      letter-spacing: .3rem;
      color: #fff;
      opacity: .6;
      cursor: pointer;
      position: relative;
      &::after {
        content: attr(back-text);
        position: absolute;
        left: -30%;
        top: 50%;
        transform: translateY(-50%);
        opacity: 0;
        font-family: Arial, Helvetica, sans-serif;
        font-weight: 800;
        color: transparent;
        -webkit-text-stroke: 1px rgba(255, 255, 255, 0.8);
        width: 100%;
        transition: all .6s;
        text-indent: 0;
        z-index: -1;
      }
      &::before {
        position: absolute;
        left: 0;
        bottom: 10%;
        content: '';
        height: 80%;
        width: 100%;
        opacity: 0;
        transition: all .6s;
        background-image: linear-gradient(to right, rgba(22, 160, 255, 1) 0%,rgba(0, 0, 0, 0) 90%, rgba(0, 0, 0, 0) 100%);
        z-index: -1;
      }

      &:hover{
        opacity: 1;
        text-indent: 2rem;
      }
      &:hover::after{
        opacity: .8;
        left: 5%;
      }
      &:hover::before{
        opacity: 1;
      }
    }
    &::after {
      content: '';
      width: 100%;
      height: 1px;
      margin-top: 1rem;
      background-image: linear-gradient(to right,rgba(0,0,0,0) 0%,rgba(255,255,255,1) 20%,rgba(255,255,255,1) 80%,rgba(0,0,0,0) 100%);
    }
  }
  .exPanel{
    display:flex;
    flex-direction:row;
    padding:1rem;
    .exButton{
      padding:.5rem 1rem ;
      letter-spacing:.4rem;
      text-align:center;
      color:#fff;
      font-size:1.1rem
    }
  }
}
.sideBarActive {
    transform: translateX(0);
    background-color: #111;
    opacity: 1;
    
    .callBar {
      opacity: 0;
      transition: opacity .6s;
      &::after {
        z-index: -1;
        filter: blur(10rem);
      }
    }
  }


.headInfo {
  margin: 2rem;
  color: #bbb;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 2rem;
  letter-spacing: .2rem;
  font-weight: 100;
  p {
    width: 100%;
    text-align: center;
  }
  .iocnBox {
    display: flex;
    justify-content: space-around;
    align-items: center;
    img {
      height: 2rem;
      width: 2rem;
      margin-left: .5rem;
      margin-right: .5rem;
      opacity: .6;
      &:hover {
        transform: scale(1.2);
        margin-left: 1rem;
        margin-right: 1rem;
        opacity: 1;
      }
    }
  }
  .profile {
    border-radius: 50%;
    height: 8rem;
    width: 8rem;
    margin-top: 2rem;
    img{
      width: 100%;
      height: 100%;
      opacity: .5;
      cursor: pointer;
      &:hover{
        opacity: 1;
      }
    }
  }
}


select{
  width: 100%;
  font-size: 2rem;
  background-color: #111;
  color: #fff;
  text-align: center;
  padding: 0;
  height: 3rem;
}
input{
  width: 100%;
  margin: 2rem 0;
  height: 3rem;
  font-size: 1.4rem;
  padding: 0;
  text-indent: 1rem;
  letter-spacing: .1rem;
  border: 1px #888 solid;
  border-radius: 0;
  background-color: #111;
  color: #fff;
}
input:focus{
    border-radius: 0;
    border: 1px #fff solid;
}

.slide-left-enter-active {
  transition: all .7s ease-out;
  position: absolute;
}

.slide-left-leave-active {
  transition: all .7s ease-in;
  position: absolute;
}

.slide-left-leave-to {
  transform: translateX(-100vw);
  opacity: 0;
}
.slide-left-enter-from{
  opacity: 0;
}
.slide-left-enter-to,
.slide-left-leave-from {
  opacity: 1;
}

@keyframes bottomIn{
  0%{
    transform: translateY(15rem);
    opacity: 0;
  }
  100%{
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes leftIn{
  0%{
    transform: translateX(-15rem);
    opacity: 0;
  }
  100%{
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes rightIn{
  0%{
    transform: translateX(15rem);
    opacity: 0;
  }
  100%{
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes leftOut {
  100%{
    opacity: 0.5;
    transform: translateX(-100%);
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
